import { sleep } from '@local_modules/generic/sleep/index.js'

import { setElementHtml } from '@local_modules/generic/dom/set-element-html.js'
import * as configVar from '../../../config/config.js'

import htmlIndexTemplate from './index.html'
// import { registerHelloWorld } from './hello-world.js'
import './hello-world.js'

export async function showWebComponentsDemo () {
  console.log('showDemoComponent')
  setElementHtml(configVar.contentElementId, htmlIndexTemplate)

  // registerHelloWorld()
  // registerHelloWorld()

  // How to change something in the hello-world component in JS?
  // Example in JS, change the name after 3 seconds
  // setTimeout(() => {
  //   const helloWorld = document.querySelector('hello-world')
  //   helloWorld.setAttribute('name', 'Bob')
  // }, 3000)

  // Create an instance of the component
  const myComponent = document.createElement('hello-world')
  myComponent.name = 'John'
  myComponent.color = 'Green'

  myComponent.config = {
    user: {
      name: 'John',
      role: 'Admin'
    },
    settings: {
      theme: 'dark',
      notifications: true
    },
    counter: 10
  }

  // myComponent._other = { me: true }
  // myComponent._context.hello = true
  // myComponent._context.counter = 0
  // myComponent._props.counter = 0
  // Append it to the body (or any container element) to display it
  document.body.appendChild(myComponent)

  myComponent.addEventListener('c-inputChanged', function (event) {
    console.log('COMPONENT inputChanged', event, myComponent.name)
  })

  myComponent.addEventListener('c-clicked', function (event) {
    console.log('COMPONENT clicked', event, 'target', event.target)
    console.log('myComponent', myComponent)
    console.log('myComponent.config', myComponent.config)
  })

  document.addEventListener('c-clicked', function (event) {
    console.log('DOCUMENT clicked', event, 'target', event.target, 'name:', event.target.name, event._other)
  })

  await sleep(3000)

  myComponent.config.user.role = 'User'
  myComponent.render()
}
